// The SETUP PICKER on Create Lead Route (step 3, 2026-10-06). Pure.
//
// ⚠️ A SETUP is create-time convenience — which fields the form shows and what
// they start as. A PROVIDER is runtime behaviour — how a lead becomes a
// submission. Choosing a setup fixes the provider, and the two must never drift
// into independent things an operator could mismatch. So a setup carries NO
// provider field of its own: it is a label plus a function that produces the
// initial form, and the provider is read off that form. There is nothing to
// keep in step, and the setup is not stored on the route.

import type { LeadProvider } from '../../types/leadRelay.js';
import { emptyAnytimeFitnessForm, emptyVirtualYardForm, type RouteFormState } from './routeForm.js';

export interface LeadRouteSetup {
  /** Stable id for the picker only — never stored on a route. */
  id: string;
  label: string;
  description: string;
  initialForm(): RouteFormState;
}

export const LEAD_ROUTE_SETUPS: readonly LeadRouteSetup[] = [
  {
    id: 'byd-ev-dealer-group',
    label: 'BYD (EV Dealer Group)',
    description: "The dealer group's VirtualYard Enquire Now form. One form for the group; the store id picks the store.",
    initialForm: emptyVirtualYardForm,
  },
  {
    id: 'anytimefitness-au',
    label: 'Anytime Fitness (AU)',
    description: "Anytime Fitness's lead-capture API, Australian clubs. The club id picks the club.",
    initialForm: () => emptyAnytimeFitnessForm('AU'),
  },
  {
    id: 'anytimefitness-nz',
    label: 'Anytime Fitness (NZ)',
    description: "Anytime Fitness's lead-capture API, New Zealand clubs. The club id (NZ-…) picks the club.",
    initialForm: () => emptyAnytimeFitnessForm('NZ'),
  },
];

export function setupById(id: string): LeadRouteSetup | null {
  return LEAD_ROUTE_SETUPS.find((s) => s.id === id) ?? null;
}

/** The provider a setup creates routes for — read off its form, never stored beside it. */
export function setupProvider(setup: LeadRouteSetup): LeadProvider {
  return setup.initialForm().provider;
}
